import { Label, PanelType, Persona, PersonaSize, ProgressIndicator, TextField } from "@fluentui/react"
import { PanelGenerico } from "../../../../components/generic/PanelGenerico"
import { TagInfo } from "../../../../components/indicadores/Tags"
import { IOpenPanel } from "../../../../Interfaces/IPanel"
import { useCallback, useState } from "react"
import { PanelDrawer } from "../../../../components/Panel/PanelDrawer"
import { ISharedUsuario } from "../../../../Interfaces/IUsuario"
import { UsePanelCambioContrasenia } from "./UsePanelCambioContrasenia"
import { PanelFooter } from "../../../../components/Panel/PanelFooter"


export interface IPanelCambiarContrasenia extends IOpenPanel{
    usuarioId:string
    sel: ISharedUsuario
}
export const PanelCambioContrasenia=(props:IPanelCambiarContrasenia)=>{
    const {_onChangeText,changePassword,validarPoliticas,disableForm,politicas,status,loading,mensaje,form,reset} = UsePanelCambioContrasenia(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Registrar"
              texto2={"Salir"}
              disableButton={disableForm}
              onClick={changePassword}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [disableForm,form]
      );
    return(
    <PanelDrawer isOpen={props.isOpen} onRenderFooter={onRenderFooter} onDismiss={reset} textHeader={"Cambiar Contraseña"} status={status} mensaje={mensaje} loading={loading}>
    <form>
                <div className="ms-Grid" dir="ltr">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                      <br />
                      <br />
                      <Persona
                        {...props.sel}
                        size={PersonaSize.size40}
                        hidePersonaDetails={false}
                        imageAlt="Annie Lindqvist, status is away"
                      />
                    </div>
                  </div>
                </div>
                <div className="ms-Grid" dir="ltr">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                      <br />
                      <TextField
                        label="Contraseña"
                        placeholder="Contraseña"
                        onChange={(e, o) => _onChangeText("password", e, o)}
                        autoComplete="off"
                        type="password"
                        canRevealPassword
                        revealPasswordAriaLabel="Show password"
                      />
                      <div>
                        {politicas.filter((item)=>item.state==false).map((item,index)=>(
                            <div key={index}>
                            <Label required
                                 style={{ color: "red", fontSize: "smaller" }}
                                 > 
                                 {item.error}
                                 </Label>
                               
                            </div>
                        ))}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                      <br />
                      <TextField
                        label="Confirmar Contraseña"
                        placeholder="Confirmar Contraseña"
                        onChange={(e, o) =>
                          _onChangeText("confirmPassword", e, o)
                        }
                        autoComplete="off"
                        type="password"
                        canRevealPassword
                        revealPasswordAriaLabel="Show password"
                      />
                    </div>
                  </div>
                </div>
              </form>

    </PanelDrawer>)
}